import axios from 'axios'
import i18next from 'i18next'

const parcelShopSearchUrl = process.env.PARCEL_SHOP_SEARCH_URL

export default class DropShopSearch {

  constructor() { }

  static searchDropShops(address, distance, country) {
    return DropShopSearch.resolveAddress(address)
      .then(data => {
        const lat = data.items[0].position.lat
        const lng = data.items[0].position.lng
        const zipCode = data.items[0].address.postalCode
        return DropShopSearch.resolveCoordinate(lat, lng, distance, country, zipCode)
          .then(data => {
            const userMarker = DropShopSearch.getUserMarker(lat, lng, address)
            const dropShops = data.data
            const preferedDropShop = dropShops[0]

            dropShops.map(dropShop => {
              // Additional data modifications for the UI components
              dropShop.id = dropShop.parcelShopId;
              dropShop.distance = dropShop.distance * 1000;
              dropShop.parcelShopLogoUrl = dropShop.partnerLogos[0] ? dropShop.partnerLogos[0].url : null;
              dropShop.openingHoursSummary = openingDaysToSummary(dropShop.openingDays);
              dropShop.partnerKey = dropShop.partnerId;

              if (dropShop.address.houseNumber) {
                dropShop.address.street = dropShop.address.street + ' ' + dropShop.address.houseNumber;
              }
            });

            return {
              dropShops,
              userMarker,
              lat,
              lng,
              preferedDropShop
            }
          })
      })
      .then(({
        dropShops,
        userMarker,
        lat,
        lng,
        preferedDropShop
      }) => {
        const markers = dropShops.map(DropShopSearch.mapDropShopMarker)

        markers.push(userMarker)

        return {
          dropShops,
          markers,
          address,
          distance,
          lat,
          lng,
          preferedDropShop
        }
      })
  }

  static resolveCoordinate(lat, lng, distance, country, zipCode) {

    const url = `${parcelShopSearchUrl}/search?latitude=${lat}&longitude=${lng}&distance=${distance}&country=${country}&zipcode=${zipCode}`;

    return axios
      .get(url)
      .then(result => result.data)
      .then(data => data.data && data.data.length > 0
        ? data
        : Promise.reject('cannot find parcelShops'));
  }

  static resolveAddress(address) {
    if (address === '' || address === null) {
      return Promise.reject('NO_ADDRESS_INGIVING');
    }

    return axios
      .get(
        `https://search.hereapi.com/v1/geocode?q=${address}&apiKey=gkQptPR3dkJnw3bJg2fPdVxAYOLO0_f3Jy0UAoR8XIQ`
      )
      .then(result => result.data)
      .then(data => {
        if (data && data.items.length === 0) {
          return Promise.reject('cannot find user address')
        }

        return data
      })
  }

  static mapDropShopMarker(dropShop, index) {

    dropShop.index = index + 1

    const distanceInKm = (dropShop.distance / 1000).toFixed(2);
    var openingHoursText = '';

    const openingHours = dropShop.openingDays
      .map(openingDay => {

        const weekday = openingDay.weekday;
        const day = capitalizeFirstLetterOnly(weekday.substring(0, 2));
        const hours = openingDay.hours;

        let translatedDay = i18next.t(i18next.t('parcelshop.' + day));
        return { translatedDay, hours }
      });

    openingHours.forEach(element => {
      let isHolidays = false;

      if (i18next.t('parcelshop.Annual_Closing') == element.translatedDay) {
        openingHoursText += "</table>" + element.translatedDay + "&nbsp"
        isHolidays = true;
      } else {
        openingHoursText += '<tr>',
          openingHoursText += '<td>' + element.translatedDay + '&nbsp&nbsp</td>';
      }

      element.hours.forEach(elementHours => {
        if (elementHours) {

          let timePeriod = elementHours.openingTime + " - " + elementHours.closingTime;

          if (isHolidays) {
            openingHoursText += "  " + timePeriod
          } else {
            openingHoursText += "<td>" + timePeriod + "&nbsp&nbsp</td>"
          }
        }
      })

      if (!isHolidays) {
        openingHoursText += '</tr>';
      }

    });

    var marker = {
      number: index + 1,
      id: dropShop.parcelShopId,
      position: {
        lat: dropShop.address.latitude,
        lng: dropShop.address.longitude
      },
      tooltip:
        `<table style="width:100%" border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td>
              <div style="font-weight: bold; color:#172154; "> ${dropShop.name} </div>
              <div> ${dropShop.address.street} </div>
              <div> ${distanceInKm} km</div>
          </td>
          <td align="right" colspan="2">
              <img src= "${dropShop.parcelShopLogoUrl}" width=65 height=50>
          </td>
       </tr>
       <tr>
          <td>
              <div style="color:#172154;">
              <br> ${openingHoursText} </div>
          </td>
       </tr>
      </table>`,

      draggable: false,
      type: 'dropShop'
    }
    return marker;
  }

  static getUserMarker(lat, lng, address) {
    let newAddress = address
    if (newAddress && newAddress.indexOf(',') >= 0) {
      newAddress = address.replace(/,/, '</br>')
    }
    var marker = {
      number: 0,
      id: 1,
      type: 'home',
      position: {
        lat: lat,
        lng: lng
      },
      name: 'user',
      tooltip: '<div>' + newAddress + '</div>',
      draggable: true
    }

    return marker
  }
}

function capitalizeFirstLetterOnly(string) {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}

function openingDaysToSummary(openingDays) {

  // Example:
  // "Mo.: #08:30 - 13:00|#14:00 - 18:00|Tu.: #08:30 - 13:00|Sa.: #09:00 - 13:00"

  var result = "";

  openingDays.forEach(day => {
    result = result.concat(capitalizeFirstLetterOnly(day.weekday.substring(0, 2)), ".: ");

    day.hours.forEach(hour => {
      result = result.concat("#", hour.openingTime, " - ", hour.closingTime, "|");
    });
  });

  return result.slice(0, -1);
}



// WEBPACK FOOTER //
// ./client/services/dropShopSearch.js